import { useRef } from "react";
import HandleUpdateSelect from "../../utils/HandleUpdateSelect"
import HandleUpdateText from "../../utils/HandleUpdateText"
import { FormatDateToDDMMYYHHMM } from "../../utils/FormatDate";
import DeleteItem from "../../utils/DeleteItem";
import { FaBarcode, FaExternalLinkAlt, FaTrash } from "react-icons/fa";
import Tooltip from "../ui/ToolTip";
import { Link } from "react-router-dom";
import CopyToClipBoard from "../../utils/CopyToClipBoard";
import HandleUpdateDNI from "../../utils/HandleValidateDNI";
import HandleUpdateRUC from "../../utils/HandleValidateRUC";
import DeleteButton from "../ui/components/DeleteButton";
import DetailsButton from "../ui/components/DetailsButton";
import IdButton from "../ui/components/IdButton";

const ItemRowLead = ({lead, setLeads, workers, countryNames, stages}) => {

  const debounceUpdate = useRef(null); // Referencia para mantener el debouncer

  return (
    <tr className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-100">
      <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
        <div className="flex flex-row gap-2 items-center justify-center w-full ">
          <DeleteButton
            action={() => DeleteItem(lead.id, "registroLeads", setLeads)}
            content="Eliminar lead"
          />
          <Link
            to={`/home/trackeoLeads/${lead.id}`} 
            target="_blank"
            rel="noopener noreferrer"
          >
            <DetailsButton
              content="Ver historial del lead"
              type="externalLink"
            />
          </Link>

          <IdButton
            action={() => CopyToClipBoard(lead.id)}
            content="ID del lead"
          />
        </div>
      </td>
      <td className="max-w-xs px-2 truncate border border-gray-300 text-center">
        <input 
          type="text"
          value={lead.leadName}
          placeholder="Nombre del lead"
          className="text-xs w-full text-gray-700 min-w-[200px] bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          onChange={(e) => HandleUpdateText("leadName", e.target.value, lead.id, "registroLeads", debounceUpdate, setLeads)}
        />
      </td>
      <td className={`${lead.responsible?.name ? "text-black" : "text-gray-200"} max-w-xs px-2 truncate border border-gray-300 text-center`}>
        <span>{lead.responsible?.name ? lead.responsible.name : "No definido"}</span>
      </td>
      <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
        {FormatDateToDDMMYYHHMM(lead.createdAt)}
      </td>
      <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
        {lead.phone}
      </td>
      <td className="px-2 truncate border border-gray-300 text-center">
        <input 
          type="text"
          value={lead.email}
          placeholder="Email"
          className="text-xs w-full min-w-[200px] text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          onChange={(e) => HandleUpdateText("email", e.target.value, lead.id, "registroLeads", debounceUpdate, setLeads)}
        />
      </td>
      <td className="px-2 truncate border border-gray-300 text-center">
        <select
          value={lead.country}
          defaultValue={41}
          onChange={(e) => HandleUpdateSelect("country", e.target.value === "" ? null : e.target.value, lead.id, "registroLeads", setLeads)}
          className="text-xs w-full min-w-[150px] text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
        >
          {countryNames.map((c) => (
            <option key={c.id} value={c.name}>{c.name}</option>
          ))}
        </select>
      </td>
      <td className={`${lead.dni ? "text-black" : "text-gray-200"} px-2 truncate border border-gray-300 text-center`}>
        {lead.entryOrigin !== "Kommo" ? (
          <input 
            type="text"
            value={lead.dni}
            placeholder="DNI"
            className="text-xs w-full min-w-[200px] text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
            onChange={(e) => HandleUpdateDNI({field: "dni", newValue: e.target.value, updateField: "leadName", targetID: lead.id, route: "registroLeads", debounceUpdate, setElements: setLeads, userCountry: lead.country})}
          />
        ) : (lead.dni ? lead.dni : "No definido")}
      </td>
      <td className={`${lead.ruc ? "text-black" : "text-gray-200"} px-2 truncate border border-gray-300 text-center`}>
        {lead.entryOrigin !== "Kommo" ? (
          <input 
            type="text"
            value={lead.ruc}
            placeholder="RUC"
            className="text-xs w-full min-w-[200px] text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
            onChange={(e) => HandleUpdateRUC({field: "ruc", newValue: e.target.value, updateField: "brandName", targetID: lead.id, route: "registroLeads", debounceUpdate, setElements: setLeads, userCountry: lead.country})}
          />
        ) : (lead.ruc ? lead.ruc : "No definido")}
      </td>
      <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
        {lead.userId ? lead.userId : "-"}
      </td>
      <td className={`${lead.entryOrigin === "Kommo" ? "text-[#6043d0]" : "text-green-500"} font-bold px-4 truncate border border-gray-300 text-center`}>
        {lead.entryOrigin ? lead.entryOrigin : "No definido"}
      </td>
      <td className="px-2 truncate border border-gray-300 text-center">
        <select
          value={lead.brandOrigin}
          onChange={(e) => HandleUpdateSelect("brandOrigin", e.target.value === "" ? null : e.target.value, lead.id, "registroLeads", setLeads)}
          className="text-xs w-full min-w-[200px] text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
        >
          <option value={""}>Seleccionar</option>
          <option value={"Sin definir"}>Sin definir</option>
          <option value={"Mundo Digital"}>Mundo Digital</option>
          <option value={"Allsavfe"}>Allsavfe</option>
          <option value={"W3P"}>W3P</option>
          <option value={"Monstruo Creativo"}>Monstruo Creativo</option>
          <option value={"SEOluciones"}>SEOluciones</option>
          <option value={"Nodo"}>Nodo</option>
          <option value={"Aura BTL"}>Aura BTL</option>
          <option value={"Conviertelo"}>Conviertelo</option>
          <option value={"Lucuma"}>Lucuma</option>
        </select>
      </td>
      <td className="px-2 truncate border border-gray-300 text-center">
        <select
          value={lead.leadOrigin}
          onChange={(e) => HandleUpdateSelect("leadOrigin", e.target.value, lead.id, "registroLeads", setLeads)}
          className="text-xs w-full text-gray-700 min-w-[200px] bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
        >
          <option value={"Sin definir"}>Sin definir</option>
          <option value={"Recomendación"}>Recomendación</option>

          <option value={"Orgánico"}>Orgánico</option>
          <option value={"Web orgánico"}>Web orgánico</option>

          <option value={"Facebook Ads"}>Facebook Ads</option>
          <option value={"Google Ads"}>Google Ads</option>
          <option value={"Linkedin Ads"}>Linkedin Ads</option>
          <option value={"Tiktok Ads"}>Tiktok Ads</option>
          <option value={"Youtube Ads"}>Youtube Ads</option>

          <option value={"Facebook"}>Facebook</option>
          <option value={"Google"}>Google</option>
          <option value={"Linkedin"}>Linkedin</option>
          <option value={"Tiktok"}>Tiktok</option>
          <option value={"Youtube"}>Youtube</option>
        </select>
      </td>
      <td className="px-2 truncate border border-gray-300 text-center">
        <select
          value={lead.stage}
          onChange={(e) => HandleUpdateSelect("stage", e.target.value === "" ? null : e.target.value, lead.id, "registroLeads", setLeads)}
          className="text-xs w-full min-w-[350px] text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
        >
          {stages.map((s) => (
            <option value={s.value}>{s.name}</option>
          ))}
        </select>
      </td>
      <td className="px-2 truncate border border-gray-300 text-center">
        <input 
          type="text"
          value={lead.sells}
          placeholder="Medicinas, plantas, servicios, etc"
          className="text-xs w-full min-w-[250px] text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          onChange={(e) => HandleUpdateText("sells", e.target.value, lead.id, "registroLeads", debounceUpdate, setLeads)}
        />
      </td>
      <td className="px-2 truncate border border-gray-300 text-center">
        <input 
          type="text"
          value={lead.ticketProduct}
          placeholder="Ticket del producto"
          className="text-xs w-full text-gray-700 min-w-[250px] bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          onChange={(e) => HandleUpdateText("ticketProduct", e.target.value, lead.id, "registroLeads", debounceUpdate, setLeads)}
        />
      </td>
      <td className="px-2 truncate border border-gray-300 text-center">
        <input 
          type="text"
          value={lead.budget}
          placeholder="Presupuesto"
          className="text-xs w-full text-gray-700 min-w-[150px] bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          onChange={(e) => HandleUpdateText("budget", e.target.value, lead.id, "registroLeads", debounceUpdate, setLeads)}
        />
      </td>
      <td className="px-2 truncate border border-gray-300 text-center">
        <input 
          type="text"
          value={lead.brandName}
          placeholder="Nombre de la empresa"
          className="text-xs w-full min-w-[250px] text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          onChange={(e) => HandleUpdateText("brandName", e.target.value, lead.id, "registroLeads", debounceUpdate, setLeads)}
        />
      </td>
      <td className="px-2 truncate border border-gray-300 text-center">
        <input 
          type="text"
          value={lead.position}
          placeholder="Puesto del lead"
          className="text-xs w-full min-w-[200px] text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          onChange={(e) => HandleUpdateText("position", e.target.value, lead.id, "registroLeads", debounceUpdate, setLeads)}
        />
      </td>
    </tr>
  )
}

export default ItemRowLead